export const countryToFlagEmoji = (countryName: string): string => {
    const nameToCodeMap: Record<string, string> = {
        austria: "AT",
        belgium: "BE",
        bulgaria: "BG",
        croatia: "HR",
        cyprus: "CY",
        "czech republic": "CZ",
        denmark: "DK",
        estonia: "EE",
        finland: "FI",
        france: "FR",
        germany: "DE",
        greece: "GR",
        hungary: "HU",
        ireland: "IE",
        italy: "IT",
        latvia: "LV",
        lithuania: "LT",
        luxembourg: "LU",
        malta: "MT",
        netherlands: "NL",
        poland: "PL",
        portugal: "PT",
        romania: "RO",
        slovakia: "SK",
        slovenia: "SI",
        spain: "ES",
        sweden: "SE",
        "united states": "US",
        canada: "CA",
        india: "IN",
        pakistan: "PK",
        bangladesh: "BD",
        "new zealand": "NZ",
        australia: "AU",
        nigeria: "NG",
        china: "CN",
        ukraine: "UA",
        "hong kong": "HK",
    };
    const normalized = countryName.trim().toLowerCase();
    const isoCode = nameToCodeMap[normalized];
    if (!isoCode) return "";

    return isoCode
        .toUpperCase()
        .replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397));
};

export const SUPPORTED_COUNTRIES = [
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
    "United States",
    "Canada",
    "India",
    "Pakistan",
    "Bangladesh",
    "New Zealand",
    "Australia",
    "Nigeria",
    "China",
    "Ukraine",
    "Hong Kong",
];

export const SUPPORTED_COUNTRY_SET = new Set<string>(
    SUPPORTED_COUNTRIES.map(c => c.toLowerCase())
);
export function isCountrySupported(country = ""): boolean {
    if (!country) return true;
    const normalized = country.trim().toLowerCase();
    return SUPPORTED_COUNTRY_SET.has(normalized);
}
